<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("whMonitoringDocumentPhotoDetail") }}
                  </h6>
                  <button
                    class="btn btn-default float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>

                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Status</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="status"
                          :value="
                            forms?.status ? forms.status.toUpperCase() : ''
                          "
                          readonly
                        />
                        <div v-if="errors.name">
                          <div
                            v-for="error in errors.name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("fulfillment") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="warehouse_id"
                          :placeholder="$t('fulfillment')"
                          :value="
                            forms.warehouse_id + ' - ' + forms?.warehouse?.name
                          "
                          readonly
                        />
                        <div v-if="errors.warehouse_id">
                          <div
                            v-for="error in errors.warehouse_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("customer") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="usernameTxt"
                          :placeholder="$t('customer')"
                          :value="
                            forms.customer_id + ' - ' + forms.customer?.name
                          "
                          readonly
                        />
                        <div v-if="errors.username">
                          <div
                            v-for="error in errors.username"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ forms.type }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="usernameTxt"
                          :placeholder="$t('customer')"
                          :value="forms.reference_no"
                          readonly
                        />
                        <div v-if="errors.username">
                          <div
                            v-for="error in errors.username"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("driver_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="driver_name"
                          :placeholder="$t('driver_name')"
                          v-model="forms.driver_name"
                          readonly
                        />
                        <div v-if="errors.driver_name">
                          <div
                            v-for="error in errors.driver_name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("vehicle_no") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="vehicle_no"
                          :placeholder="$t('vehicle_no')"
                          v-model="forms.vehicle_no"
                          readonly
                        />
                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Images</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <div class="row mb-2">
                          <vue-dropzone
                            ref="myVueDropzone"
                            id="dropzone"
                            :options="dropzoneOptions"
                            @vdropzone-file-added="addFile"
                            @vdropzone-removed-file="removeFile"
                            @vdropzone-duplicate-file="removeFile"
                            :duplicateCheck="true"
                            @vdropzone-thumbnail="thumbnailGenerated"
                          ></vue-dropzone>
                        </div>
                        <div class="row">
                          <div
                            class="col-auto d-flex flex-column align-items-center"
                            v-for="(image, index) in images"
                            :key="index"
                          >
                            <img
                              :src="image.src"
                              class="img-thumbnail"
                              style="
                                cursor: pointer;
                                width: auto;
                                height: 100px;
                              "
                              @click="
                                visible = true;
                                imageIndex = index;
                                imageLightbox = images;
                              "
                            />
                            <div class="overlay">
                              <i class="fas fa-search-plus magnifier-icon"></i>
                            </div>
                          </div>
                        </div>
                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <vue-easy-lightbox
                      escDisabled
                      moveDisabled
                      :visible="visible"
                      :imgs="imageLightbox"
                      :index="imageIndex"
                      @hide="handleHide"
                    ></vue-easy-lightbox>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import VueEasyLightbox from "vue-easy-lightbox";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import imageCompression from "browser-image-compression";

export default {
  name: "DocumentPhotoEdit",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    vueDropzone: vue2Dropzone,
    VueEasyLightbox,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      fetchRole: [],
      fetchCompany: [],
      fetchCompanyNotLinc: [],
      forms: [],
      company: [],
      role: [],
      permision_role: [],
      fetchUserType: [],
      user_type: [],
      imgs: [],
      visible: false,
      imageIndex: 0,
      dropzoneOptions: {
        url: "http://localhost",
        thumbnailWidth: 300,
        autoProcessQueue: false,
        // maxFilesize: 2, // MB
        addRemoveLinks: true,
        previewTemplate: this.template(),
        // headers: { "My-Awesome-Header": "header value" }
      },
      images: [],
      imagesUpload: [],
      imageLightbox: [],
    };
  },
  watch: {},
  methods: {
    handleHide() {
      this.visible = false;
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
          <div class="dz-image">
            <img data-dz-thumbnail />
          </div>
          <div class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
            <div class="dz-size" data-dz-size></div>
          </div>
          <div class="dz-success-mark"><span>✔</span></div>
          <div class="dz-error-mark"><span>✘</span></div>
          <div class="dz-error-message"><span data-dz-errormessage></span></div>
          <div class="dz-remove" data-dz-remove>Remove file</div>
          <button class="btn btn-primary my-custom-button" type="button" data-dz-custom-button><i class="mdi mdi-eye"></i></button>
        </div>
        `;
    },
    thumbnailGenerated(file) {
      // Access the custom button for this specific file
      const customButton =
        file.previewElement.querySelectorAll(".my-custom-button");
      let imgLength = this.imgs.length - 1;
      for (var i = 0; i < customButton.length; i++) {
        customButton[i].addEventListener("click", () => {
          this.handleCustomButtonClick(file, imgLength);
        });
      }
    },
    handleCustomButtonClick(file, index) {
      // console.log('Custom button clicked for file:', file.name, 'index:', index);
      // // Implement your custom logic here, e.g., open a modal, apply a filter, etc.
      // alert(`Custom button clicked for ${file.name}`);
      this.imageLightbox = this.imgs;
      this.imageIndex = index;
      this.visible = true;
    },
    removeFile() {
      this.imagesUpload = this.$refs.myVueDropzone.getAcceptedFiles();
      this.imgs = this.$refs.myVueDropzone.getAcceptedFiles().map((file) => {
        return URL.createObjectURL(file);
      });
    },
    async addFile(file) {
      const options = {
        maxSizeMB: 0.7, // max file size in MB
        useWebWorker: true, // use web worker for performance
      };
      
      // Check Uploaded File Is Greater Than 1.5 MB
      let fileMb = file.size / 1024 / 1024;
      if (fileMb > 1) {
        this.isLoading = true;
        try {
          const compressedFile = await imageCompression(file, options);

          let finalFile = new File([compressedFile], file.name, {
            type: compressedFile.type,
          });

          this.imagesUpload.push(finalFile);
          this.imgs.push(URL.createObjectURL(finalFile));
          this.loading();
        } catch (error) {
          console.error("Image compression failed:", error);
          this.loading();
        }
      } else {
        this.imagesUpload.push(file);
        this.imgs.push(URL.createObjectURL(file));
      }
    },

    resetForm() {
      this.forms = {};
    },

    backForm() {
      window.location.href = "/wh-monitoring/document-photo";
    },

    loadData(id) {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/document-header/detail/" + id;
      this.isLoading = true;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.forms = response.data.datas;
          if(this.forms?.details.length > 0){
              this.forms.details.forEach((item) => {
                
                this.images.push({
                  src:item.url,
                  title:item.file_name,
                  document_detail_id:item.document_detail_id,
                });
              });
            }
            this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    submitData() {
      this.fade(true);

      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/document-header/add-detail/" +
        this.forms.document_header_id;

        let formData = new FormData();
        this.imagesUpload.forEach((file) => {
          formData.append("details[]", file);
        });
      this.$http
        .post(baseURI, formData, { timeout: 100000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];
            window.location.href =
              "/wh-monitoring/document-photo/detail/" +
              this.$route.params.id +
              "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
          this.loading();
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
          this.loading();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller == "WhMonitoringDocumentHeaderController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.fetchIt();
    this.loadData(params[0]);
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
  pointer-events: none;
}
</style>
